export default __webpack_public_path__ + "static/home-slide-small001-0d45ecaed71d5687def64c94c7e404b5.jpg";